import { render, staticRenderFns } from "./AdminOrderSummary.vue?vue&type=template&id=a5d55034&scoped=true"
import script from "./AdminOrderSummary.vue?vue&type=script&lang=js"
export * from "./AdminOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderSummary.vue?vue&type=style&index=0&id=a5d55034&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d55034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5d55034')) {
      api.createRecord('a5d55034', component.options)
    } else {
      api.reload('a5d55034', component.options)
    }
    module.hot.accept("./AdminOrderSummary.vue?vue&type=template&id=a5d55034&scoped=true", function () {
      api.rerender('a5d55034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminOrderSummary.vue"
export default component.exports